<template>
  <section
    class="simulate-button-container"
    v-bind:data-title="tooltipValue"
    data-toggle="tooltip"
    data-placement="top"
  >
    <button
      class="simulate-button btn btn-primary btn-block"
      v-on:click="$emit('simulate')"
      v-bind:disabled="disabled"
    >
    </button>
    <span class="text">Simulate</span>
    <div class="progress-box"></div>
  </section>
</template>

<script>
export default {
  name: 'simulate-button',
  props: ['disabled'],
  computed: {
    tooltipValue: function () {
      // if (this.disabled) {
      //   return 'Disabled.';
      // }

      return ''; // disables the tooltip
    },
  },
  mounted: function () {
    if (process.env.NODE_ENV !== 'testing') {
      $(this.$el).tooltip();
    }
  },
};
</script>

<style lang="scss" scoped>
  @import "src/assets/mixins";

  .simulate-button-container {
    position: relative;
  }

  .simulate-button {
    height: 31px;
  }

  .text {
    @include noselect;
    position: absolute;
    left: 50%;
    top: 50%;
    color: white;
    transform: translate(-50%, -50%);
    z-index: 2;
    pointer-events: none;
  }

  .progress-box {
    width: 0%;
    height: 31px;
    background: #337ab7;
    border-radius: 4px 0 0 4px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    text-align: center;
  }

  .btn-primary[disabled] {
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/controls/simulate-button.vue